import React, { useEffect, useState } from "react";
import { Users, UserCog, Wallet, TrendingUp, Trophy, Gift, FileText, AlertTriangle } from "lucide-react";
import api, { fmtINR } from "@/lib/api";

const Card = ({ icon: Icon, label, value, tone }) => {
  const tones = {
    primary: "bg-blue-50 text-tenant-primary",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    violet: "bg-violet-50 text-violet-600",
    rose: "bg-rose-50 text-rose-600",
  };
  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
      <div className={`w-10 h-10 rounded-xl grid place-items-center ${tones[tone]}`}><Icon className="w-5 h-5" /></div>
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400 mt-3">{label}</div>
      <div className="text-xl font-extrabold tracking-tight mt-0.5">{value}</div>
    </div>
  );
};

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  const [r, setR] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((res) => setD(res.data));
    api.get("/admin/reports/overview").then((res) => setR(res.data));
  }, []);
  if (!d) return <div className="p-6 text-center text-slate-500">Loading...</div>;
  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl font-extrabold tracking-tight">Admin Dashboard</h1>
      <p className="text-sm text-slate-500">Tenant-wide overview & operations</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
        <Card icon={Users} label="Total Customers" value={d.total_customers} tone="primary" />
        <Card icon={UserCog} label="Total Agents" value={d.total_agents} tone="violet" />
        <Card icon={Wallet} label="Total Savings" value={fmtINR(d.total_savings)} tone="emerald" />
        <Card icon={TrendingUp} label="Total Collections" value={fmtINR(d.total_collections)} tone="amber" />
        <Card icon={Wallet} label="Saving Wallet" value={fmtINR(d.total_saving_wallet)} tone="emerald" />
        <Card icon={Gift} label="Bonus Wallet" value={fmtINR(d.total_bonus_wallet)} tone="violet" />
        <Card icon={FileText} label="Active Policies" value={d.active_policies} tone="primary" />
        <Card icon={AlertTriangle} label="Pending Withdrawals" value={d.pending_withdrawals} tone="rose" />
      </div>

      {r && (
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400">Total Collections</div>
            <div className="text-2xl font-extrabold tracking-tight mt-1">{fmtINR(r.collections_total)}</div>
            <div className="text-xs text-slate-500 mt-1">{r.collections_count} entries</div>
          </div>
          <div className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400">Total Withdrawals</div>
            <div className="text-2xl font-extrabold tracking-tight mt-1">{fmtINR(r.withdrawals_total)}</div>
          </div>
          <div className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400">Bonus Paid</div>
            <div className="text-2xl font-extrabold tracking-tight mt-1 text-violet-700">{fmtINR(r.bonus_paid_total)}</div>
          </div>
        </div>
      )}
    </div>
  );
}
